import { useQuery } from '@tanstack/react-query'
import { istTeam } from '@netcon-work/shared'
import { sitzungQuery } from '../../lib/queries'
import { trpc } from '../../lib/trpc'

/**
 * **„✦ Entwurf von Claude wartet"** ([Z-25](../../../../../docs/phasen/zusatz-25-claude-planung.md)
 * AP 25.9) – über „Klopft an" in Mein Tag und My Work.
 *
 * Eine eigene Zeile und nicht eine Klopfmeldung: die gehören an eine Aufgabe, ein Entwurf hat
 * noch keine. Wie „Klopft an" ist sie normalerweise nicht da – nur, solange ein Entwurf offen ist.
 */
export const offeneEntwuerfeQuery = {
  queryKey: ['planEntwurf', 'liste', 'offen'],
  queryFn: () => trpc.planEntwurf.liste.query({ nurOffene: true }),
  refetchInterval: 60_000,
}

export function useOffeneEntwuerfe() {
  const { data: sitzung } = useQuery(sitzungQuery)
  const darf = Boolean(sitzung?.claudePlanung && istTeam(sitzung.role))
  const { data = [] } = useQuery({ ...offeneEntwuerfeQuery, enabled: darf })
  return darf ? data : []
}

export function EntwurfHinweis() {
  const offen = useOffeneEntwuerfe()
  if (offen.length === 0) return null
  const erster = offen[0]!
  return (
    <a
      href={offen.length === 1 ? `/entwurf/${erster.id}` : '/entwuerfe'}
      className="mb-3 flex flex-wrap items-baseline gap-x-2.5 gap-y-0.5 rounded-xl border border-[#d9cff5] border-l-[3px] border-l-[#7c5cd6] bg-[#faf8ff] px-3.5 py-2 text-[13px] hover:bg-[#f3effd]"
    >
      <span className="shrink-0 text-[11px] font-bold tracking-[0.04em] text-[#5b3fa8] uppercase">
        ✦ Entwurf von Claude
      </span>
      <span className="min-w-0 flex-1 font-semibold">
        {offen.length === 1 ? erster.titel : `${offen.length} Entwürfe warten`}
      </span>
      <span className="text-[12px] text-[#5b3fa8]">
        {erster.rueckmeldungAm ? 'wartet auf Claude' : 'ansehen & übernehmen'} →
      </span>
    </a>
  )
}
